<template>
    <div class="resource_subject_add_wrap">
        <div class="header">
            <el-button size="medium" @click="$router.back()">返回</el-button>
            <el-button size="medium" type="primary" @click="jumpToPage('sqlTemplateExec', {id})">执行</el-button>
        </div>
        <div class="resource_subject_box" :style="`height: ${windowHeight - 170}px;`">
            <div class="resource_subject_content">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="所属模块" prop="moduleName">
                        {{formData.moduleName}}
                    </el-form-item>
                    <el-form-item label="模板名称" prop="tempName">
                        {{formData.tempName}}
                    </el-form-item>
                    <el-form-item label="模板内容" prop="tempContext">
                        {{formData.tempContext}}
                    </el-form-item>
                    <el-form-item label="模板分类" prop="tempType">
                        {{['', '查询', '更新数据', '删除数据', '修改表结构', '删除表'][formData.tempType]}}
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import baseMixin from '@/mixins/baseMixin';

    import {
        sqlToolTemplateQuery
    } from '@/api/sql';
    export default {
        name: "sqlTemplateDetail",
        data() {
            return {
                id: this.$route.query.id,
                formData: {
                    moduleName: '',
                    tempContext: '',
                    tempName: '',
                    tempType: 1,
                }
            }
        },
        mixins: [baseMixin],
        mounted() {
            sqlToolTemplateQuery({
                sqlTemplateId: this.id
            })
                .then(data => {
                    this.formData = data;
                })
        }
    }
</script>

<style lang="scss" scoped>
    @import './../../styles/mixin';

    .resource_subject_add_wrap {
        padding: 12px;

        .header {
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }

        .resource_subject_box {
            @include scrollBar;

            .resource_subject_content {
                width: 810px;
                margin: 0 auto;
                padding-top: 20px;

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/sql/sqlTemplateDetail.vue